import { CardPaymentMethod, PaymentMethod, PaymentRequestState, SepaPaymentMethod } from '@mews-commander/data-access';
import { parsePaymentCardExpirationDate } from '@mews/framework';
import { NEW_CREDIT_CARD_VALUE } from './constants';

export const isPaymentRequestUnresolved = (state: PaymentRequestState) => state === PaymentRequestState.Pending;

export const isNewCard = (id: string) => id === NEW_CREDIT_CARD_VALUE;

export const formatCardExpiration = (expiration?: string) => {
    if (!expiration) {
        return undefined;
    }

    const { year, month } = parsePaymentCardExpirationDate(expiration);

    return `${year}-${month}`;
};

export const isCardPaymentMethod = (
    paymentMethod: CardPaymentMethod | SepaPaymentMethod
): paymentMethod is CardPaymentMethod => paymentMethod.paymentMethod === PaymentMethod.PaymentCard;
export const isSepaPaymentMethod = (
    paymentMethod: CardPaymentMethod | SepaPaymentMethod
): paymentMethod is SepaPaymentMethod => paymentMethod.paymentMethod === PaymentMethod.SepaDirectDebit;
